export default {"src":"/_next/static/media/section7-img.ed38adf2.svg","height":491,"width":573,"blurWidth":0,"blurHeight":0};